<button [attr.type]="type"
        [disabled]="disabled || loading"
        (click)="handleClick()" class="tracking-wide flex items-center justify-center py-[10px] border-1
        rounded-full transition duration-200 ease-in-out focus:outline-none  text-base font-medium"
        [ngClass]="getButtonClasses()">

  <div [ngClass]="[loading ? 'opacity-0' : 'opacity-100']" class="flex items-center px-2 justify-center">
        <span class="flex shrink-0 items-center">
        @if (iconTemplate) {
          <ng-container>
            <ng-template [ngTemplateOutlet]="iconTemplate"></ng-template>
          </ng-container>
        }
      </span>
  </div>
  <ng-container>
    <vw-loading-icon class="inline text-white absolute"
                     [ngClass]="loading ? 'opacity-100' : 'opacity-0'"></vw-loading-icon>
  </ng-container>
</button>
